import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { JwtLegFiClaims } from './auth/jwt-legfi-claims.model';
import { LegFiJwtService } from './auth/legfi-jwt.service';
import { Routes } from '../config/routes';
import { ApplicationHttpClient } from '../components/shared/http/application-http-client';
import { BehaviorSubject, Observable } from 'rxjs';
import { PlaidToken } from '../models/entities/plaid-token';

@Injectable({
    providedIn: 'root',
})
export class PlaidTokenService
{
    public $tokens: BehaviorSubject<PlaidToken[]> = new BehaviorSubject<PlaidToken[]>([]);
    private _tokens: PlaidToken[] = [];


    constructor(
            private _http: ApplicationHttpClient,
    ) {
    }

    public createToken(publicToken: string, institutionId: string): Observable<PlaidToken> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url: string = Routes.MakeLegFiCoreUrl(Routes.LegFiCore.PlaidTokens);

        return this._http.post(url, JSON.stringify({publicToken: publicToken, institutionId: institutionId}))
                .pipe(map((response: any) => {
                    const newToken = new PlaidToken(response);
                    this._tokens.push(newToken);
                    this.$tokens.next(this._tokens);
                    return newToken;
                }));
    }

    public getTokens(): Observable<PlaidToken[]> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url: string = Routes.MakeLegFiCoreUrl(Routes.LegFiCore.PlaidTokens);
        return this._http.get(url).pipe(map((response: Object[]) => {
            const tokens = response.map(element => new PlaidToken(element));
            this._tokens = tokens;
            this.$tokens.next(this._tokens);
            return tokens;
        }));
    }

    public getToken(plaidTokenId: number): Observable<PlaidToken> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url: string = Routes.MakeLegFiCoreUrl(Routes.LegFiCore.PlaidTokens) + '/' + plaidTokenId;
        return this._http.get(url).pipe(map((response: any) => {
            const token = new PlaidToken(response);
            const index = this._tokens.findIndex(element => element.id === token.id);
            if (index === -1) {
                this._tokens.push(token);
            } else {
                Object.assign(this._tokens[index], token);
            }
            this.$tokens.next(this._tokens);
            return token;
        }));
    }

    public deleteToken(plaidTokenId: number): Observable<void> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url: string = Routes.MakeLegFiCoreUrl(Routes.LegFiCore.PlaidTokens) + '/' + plaidTokenId;

        return this._http.delete(url).pipe(map(() => {
            const index = this._tokens.findIndex(element => element.id === plaidTokenId);
            if (index !== -1) {
                this._tokens.splice(index, 1);
                this.$tokens.next(this._tokens);
            }
            return;
        }));
    }
}
